<template>
  <div class="tabs-block">
    <div class="tabs-block__buttons">
      <button type="button" class="tabs-block__tab-btn base-btn"
              v-for="tab in tabs"
              :key="tab.id"
              :class="{'_active': computedActiveTab === tab}"
              @click.prevent="switchTab(tab)"
      >
        <span class="base-btn__text">
          <slot name="tab" :tab="tab">{{ tab }}</slot>
        </span>
      </button>
    </div>
    <div class="tabs-block__wrap">
      <div class="tabs-block__content">
        <slot name="content" :tab="computedActiveTab"/>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "TabsBlock",
    props: {
      initialTab: {
        type: Object
      },
      tabs: {
        type: Array,
        default: () => []
      }
    },
    data() {
      return {
        activeTab: null
      };
    },
    computed: {
      computedActiveTab() {
        return this.activeTab || this.initialTab || this.tabs[0] || null
      }
    },
    methods: {
      switchTab(tab) {
        this.activeTab = tab
      }
    }
  }
</script>

<style>

</style>
